import React, { PropsWithChildren } from 'react';
import useRoute from '@/Hooks/useRoute';
import useTrackingHook from '@/Hooks/useTrackingHook';

interface Props {
  file: App.Data.FileData;
  className?: string;
}

export default function FileDownloadButton({
  file,
  children,
  ...rest
}: PropsWithChildren<Props>) {
  const route = useRoute();
  const { track } = useTrackingHook();

  return (
    <a
      href={route('files.download', file.id)}
      onClick={() =>
        track('file:downloaded', {
          file_id: file.id,
        })
      }
      {...rest}
    >
      {children}
    </a>
  );
}
